import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Presentation from "@/pages/Presentation";
import AdminLeads from "@/pages/AdminLeads";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Presentation />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
